import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Table,Button } from "react-bootstrap";
import { BASE_URL } from "../../api/api";
import GetAppIcon from "@mui/icons-material/GetApp"; 
const VendorInvoices = () => {
    const { vendorName } = useParams();
    const [invoiceData, setInvoiceData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");

    useEffect(() => {
        const fetchInvoices = async () => {
            try {
                const res = await fetch(`${BASE_URL}/GetInvoicesByVendor`, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ vendorName }),
                });

                const data = await res.json();
                if (data?.status && data?.dataList) {
                    setInvoiceData(data.dataList);
                    setFilteredData(data.dataList);
                }
            } catch (error) {
                console.error("Error fetching invoices:", error);
            }
        };

        fetchInvoices();
    }, [vendorName]);

    const handleFilter = () => {
        if (!fromDate && !toDate) {
            setFilteredData(invoiceData);
            return;
        }

        const from = fromDate ? new Date(fromDate) : null;
        const to = toDate ? new Date(toDate) : null;

        const filtered = invoiceData.filter((inv) => {
            const invDate = new Date(
                inv.createdDate.split(" ")[0].split("-").reverse().join("-") // convert DD-MM-YYYY to YYYY-MM-DD
            );
            if (from && invDate < from) return false;
            if (to && invDate > to) return false;
            return true;
        });

        setFilteredData(filtered);
    };
    const handleDownload = () => {
        if (!filteredData || filteredData.length === 0) return;

        const headers = Object.keys(filteredData[0]);

        const rows = filteredData.map((row) =>
            headers.map((header) => row[header] ?? "-").join(",")
        );

        const csvContent = [headers.join(","), ...rows].join("\n");

        const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
        const url = URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "table_data.xlsx");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };
    return (
        <div className="container mt-4">
            <h4>Invoices for {vendorName}</h4>

            <div
                className="pt-3"
                style={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "20px",
                    alignItems: "end",
                }}
            >
                <div className="d-flex flex-column" style={{ width: "22%" }}>
                    <label htmlFor="fromDate" className="mb-1 text-sm font-medium">
                        From Date
                    </label>
                    <input
                        type="date"
                        className="form-control searchInput"
                        value={fromDate}
                        onChange={(e) => setFromDate(e.target.value)}
                    />
                </div>

                <div className="d-flex flex-column" style={{ width: "22%" }}>
                    <label htmlFor="toDate" className="mb-1 text-sm font-medium">
                        To Date
                    </label>
                    <input
                        type="date"
                        className="form-control searchInput"
                        value={toDate}
                        onChange={(e) => setToDate(e.target.value)}
                    />
                </div>

                <div className="pt-3">
                    <button
                        className="btn btn-primary"
                        style={{ backgroundColor: "#7E00D1", border: "0px", width: "200px" }}
                        onClick={handleFilter}
                    >
                        Submit
                    </button>
                </div>
                {/* <div className="d-flex justify-content-end mb-2">
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={handleDownload}
                    >
                       <GetAppIcon></GetAppIcon>
                    </Button>
                </div> */}
            </div>

            {filteredData.length > 0 ? (
                <Table className="bg-white text-center border-0 network_table mt-3">
                    <thead
                        style={{
                            backgroundColor: "#EEF4FF",
                            position: "sticky",
                            top: 0,
                            zIndex: 1,
                        }}
                    >
                        <tr className="text-dark fw-semibold table_th_border">
                            <th>Invoice Number</th>
                            <th>Vendor Name</th>
                            <th>Created Date</th>
                        </tr>
                    </thead>
                    <tbody>
                        {filteredData.map((invoice, idx) => (
                            <tr key={idx}>
                                <td>{invoice.invoiceNumber}</td>
                                <td>{invoice.vendorName}</td>
                                <td>{invoice.createdDate}</td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            ) : (
                <p className="mt-3">No invoices found for {vendorName}</p>
            )}
        </div>
    );
};

export default VendorInvoices;
